<template>
  <div class="d-print-none">
    <v-app-bar
      flat
      app
      clipped-left
      color="light-green lighten-3"
      class="text--darken-4"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />

      <v-toolbar-title>
        <LogoText />
      </v-toolbar-title>

      <v-spacer />

      <UserMenu></UserMenu>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app clipped dark>
      <v-list>
        <v-list-item v-if="isLoggedIn">
          <v-list-item-content>
            <v-list-item-title>
              {{ currentUser.email }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-for="item in allowedItems"
          :key="item.text"
          link
          :to="item.route"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserMenu from "@/components/UserMenu.vue";

export default {
  name: "NavBar",
  components: {
    UserMenu
  },
  data: () => ({
    drawer: false,
    items: [
      { text: "About", icon: "mdi-information", route: { name: "about" } },
      {
        auth: true,
        text: "Courses",
        icon: "mdi-bookshelf",
        route: { name: "courses" }
      },
      {
        auth: true,
        text: "Lessons",
        icon: "mdi-book-multiple",
        route: { name: "lessons" }
      },
      {
        auth: true,
        text: "Catalog",
        icon: "mdi-music-box-multiple",
        route: { name: "catalog" }
      },
      {
        auth: true,
        text: "Editor",
        icon: "mdi-pencil",
        route: { name: "editor" }
      },
      {
        auth: false,
        text: "Games",
        icon: "mdi-controller-classic",
        route: { name: "games" }
      },
      {
        auth: true,
        text: "Account",
        icon: "mdi-account-box",
        route: { name: "account" }
      }
    ]
  }),
  computed: {
    ...mapGetters("accounts", ["isLoggedIn", "currentUser"]),
    allowedItems() {
      return this.items.filter(item => this.isLoggedIn || !item.auth);
    }
  }
};
</script>
